var _path, _path2, _path3, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDescription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.62673 25.509C8.40536 23.5202 8.85932 19.8236 9.29707 18.5049L10.513 18.2077C10.513 18.2077 10.205 16.3702 11.5939 14.5922C13.2638 12.4521 18.0359 8.19889 27.2124 7.69629C23.8563 11.4361 21.4622 17.8078 20.8677 18.7481C19.6193 19.5966 18.4034 20.1695 18.4034 20.1695L19.5113 21.2503C19.5113 21.2503 13.3665 26.5304 9.62673 25.5144V25.509Z",
    stroke: "black",
    strokeWidth: 1.7,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0733 12.9871C13.0747 18.2941 9.44836 25.0117 8 29.4216",
    stroke: "black",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 29.7852C10.7458 29.3097 14.8963 27.1858 13.783 29.7852C12.6697 32.3847 19.2468 28.5639 20.2898 27.937C21.2572 27.3587 22.4678 26.7102 23.8243 26.2886C26.4292 25.478 29.5421 26.3481 28.3747 29.2394",
    stroke: "black",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 18,
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescription);
export default __webpack_public_path__ + "static/media/description.34f7b7539d97c3f82f9f8d3c964be2a4.svg";
export { ForwardRef as ReactComponent };